import { useState } from 'react';
// 滚屏配置参数
export type OptionsPropsTpe = {
  scrollType: number;
  scrollSpeed: string;
  scrollInterval: string;
  displayCount: string;
  orderTime: number;
  fixedDisplay: string[];
  scrollDisplay: string[];
};
export default () => {
  const [ottScrollScreen, setOttScrollScreen] = useState<{
    createdTime: any[]; // 下单时间
    orderStatus: any[]; // 订单状态
    optionsProps: OptionsPropsTpe;
  }>({
    createdTime: [], // 下单时间
    orderStatus: [], // 订单状态
    optionsProps: {
      scrollType: 1, // 默认值
      scrollSpeed: '',
      scrollInterval: '',
      displayCount: '',
      orderTime: 1, // 默认值
      fixedDisplay: [],
      scrollDisplay: [],
    },
  }); // 分配选择的id

  //   const getPreOrderIds = useCallback(async () => {
  //     // setState((s) => ({ ...s, loading: true, error: undefined }));
  //     const preOrderData: any = JSON.parse(sessionStorage.getItem('pre-order-data') || '{}');

  //     console.log(
  //       '🚀 7848489494984',
  //       preOrderData,
  //       JSON.parse(sessionStorage.getItem('pre-order-data') || '{}'),
  //     );

  //     if (preOrderData) {
  //       setPreOrderIds(preOrderData.ids);
  //       setTemplateId(preOrderData.template_id);
  //     }
  //     return preOrderData;
  //   }, []);
  //   const test = useCallback(async () => {
  //     return preOrderSum;
  //   }, []);
  return {
    ottScrollScreen,
    setOttScrollScreen,

    // test,
  };
};
